import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
    FaSms,
    FaExclamationTriangle,
    FaHistory,
    FaBell,
    FaEnvelope,
    FaMobileAlt,
    FaCog
} from "react-icons/fa";

// Import tab components
import FoodSmsSettings from "./FoodSmsSettings";
import FoodCustomAlerts from "./FoodCustomAlerts";
import FoodNotificationHistory from "./FoodNotificationHistory";

function NotificationHub() {
    // State for UI - using the same tab structure as FoodPramotions
    const [activeTab, setActiveTab] = useState("Notifications Hub");
    const [isMobile, setIsMobile] = useState(false);

    // Check screen size
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Tab content mapping - exactly like FoodPramotions
    const tabContent = {
        "Notifications Hub": <FoodSmsSettings isMobile={isMobile} />,
        "Notification History": <FoodNotificationHistory isMobile={isMobile} />,
        "Custom Alert": <FoodCustomAlerts isMobile={isMobile} />
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-10 food-pramotions-data-scroll" style={{ height: "80vh", overflowY: "auto", scrollbarWidth: "none" }} >
                    <p
                        className="breadcrumb maamaas-home-bredcum or22"
                        style={{
                            position: "fixed",
                            top: "57px",
                            left: "1vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            // zIndex: 1000,
                            padding: "10px 0",
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        <Link
                            to="/Homes"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link>

                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            <Link
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Notifications
                            </Link>
                        </span>
                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Food & Beverages
                        </span>
                    </p>
                    
                    <div className="discount-container">
                        {/* EXACT SAME TAB BUTTONS AS FoodPramotions */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "fixed",
                                top: "125px",
                                left: "55%",
                                transform: "translate(-45%, -50%)",
                                gap: "0px",
                                zIndex: 10,
                                width: "100vw",
                                maxWidth: "600px",
                                flexWrap: "wrap",
                                padding: "10px 0",
                            }}
                            className="rorr row b2"
                        >
                            {Object.keys(tabContent).map((label) => (
                                <div
                                    key={label}
                                    className="col-lg-4 col-md-6 col-sm-12 col-12"
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        marginBottom: "10px",
                                        minWidth: "150px",
                                    }}
                                >
                                    <button
                                        onClick={() => setActiveTab(label)}
                                        style={{
                                            border: "none",
                                            borderRadius: "10px",
                                            minWidth: "140px",
                                            width: "100%",
                                            padding: "0 10px",
                                            height: "40px",
                                            backgroundColor: activeTab === label ? "#b15cd6" : "#d9d9d9",
                                            color: activeTab === label ? "#fff" : "#000",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            transition: "background-color 0.3s ease",
                                            fontSize: "1rem",
                                        }}
                                    >
                                        {label}
                                    </button>
                                </div>
                            ))}
                        </div>
                        
                        {/* Tab Content - Scrollable Part */}
                        <div
                            style={{
                                height: "95vh",
                                overflowY: "auto",
                                scrollbarWidth: "none",
                                borderRadius: "8px",
                                marginTop: "0px",
                            }}
                            className="b1"
                        >
                            {/* ALL ORIGINAL CONTENT INSIDE EACH TAB */}
                            <div style={{ 
                                padding: isMobile ? '20px' : '30px',
                                maxWidth: '1200px',
                                margin: '0 auto'
                            }}>
                                {/* Notifications Hub Tab Content */}
                                {activeTab === "Notifications Hub" && (
                                    <>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '15px',
                                            marginBottom: '30px',
                                            paddingBottom: '20px',
                                            borderBottom: '1px solid #e0e0e0'
                                        }}>
                                            <div style={{
                                                width: '48px',
                                                height: '48px',
                                                borderRadius: '12px',
                                                backgroundColor: '#f5f3ff',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: '#6B46C1',
                                                fontSize: '22px'
                                            }}>
                                                <FaBell />
                                            </div>
                                            <div>
                                                <h2 style={{
                                                    margin: '0 0 5px 0',
                                                    fontSize: isMobile ? '20px' : '24px',
                                                    fontWeight: '600',
                                                    color: '#1a1a1a'
                                                }}>
                                                    Notifications Hub
                                                </h2>
                                                <p style={{
                                                    margin: 0,
                                                    fontSize: isMobile ? '14px' : '16px',
                                                    color: '#666'
                                                }}>
                                                    Configure Push, Email, and SMS Notification Settings
                                                </p>
                                            </div>
                                        </div>

                                        {/* SMS Settings Component */}
                                        <FoodSmsSettings isMobile={isMobile} />

                                        {/* Email Settings Section */}
                                        <div style={{
                                            marginTop: '30px',
                                            padding: isMobile ? '20px' : '30px',
                                            backgroundColor: '#f9fafb',
                                            borderRadius: '12px',
                                            border: '1px solid #e5e7eb'
                                        }}>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '15px',
                                                marginBottom: '20px'
                                            }}>
                                                <div style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '8px',
                                                    backgroundColor: '#dbeafe',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    color: '#3b82f6',
                                                    fontSize: '18px'
                                                }}>
                                                    <FaEnvelope />
                                                </div>
                                                <div>
                                                    <h3 style={{
                                                        margin: '0 0 5px 0',
                                                        fontSize: isMobile ? '16px' : '18px',
                                                        fontWeight: '600',
                                                        color: '#1a1a1a'
                                                    }}>
                                                        Email Notifications
                                                    </h3>
                                                    <p style={{
                                                        margin: 0,
                                                        fontSize: isMobile ? '13px' : '14px',
                                                        color: '#666'
                                                    }}>
                                                        Manage your email notification preferences
                                                    </p>
                                                </div>
                                            </div>
                                            <div style={{
                                                display: 'grid',
                                                gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))',
                                                gap: '15px'
                                            }}>
                                                <div style={{
                                                    backgroundColor: 'white',
                                                    padding: '20px',
                                                    borderRadius: '8px',
                                                    border: '1px solid #e5e7eb'
                                                }}>
                                                    <h4 style={{
                                                        margin: '0 0 10px 0',
                                                        fontSize: '14px',
                                                        fontWeight: '600',
                                                        color: '#374151'
                                                    }}>
                                                        Order Updates
                                                    </h4>
                                                    <p style={{
                                                        margin: '0 0 15px 0',
                                                        fontSize: '13px',
                                                        color: '#6b7280'
                                                    }}>
                                                        Receive emails for new orders, updates, and cancellations
                                                    </p>
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between'
                                                    }}>
                                                        <span style={{
                                                            fontSize: '13px',
                                                            color: '#10b981',
                                                            fontWeight: '500'
                                                        }}>
                                                            Enabled
                                                        </span>
                                                        <button
                                                            onClick={() => alert('Email settings updated')}
                                                            style={{
                                                                padding: '6px 12px',
                                                                backgroundColor: '#f3f4f6',
                                                                color: '#374151',
                                                                border: '1px solid #d1d5db',
                                                                borderRadius: '6px',
                                                                cursor: 'pointer',
                                                                fontSize: '12px',
                                                                fontWeight: '500'
                                                            }}
                                                        >
                                                            Edit
                                                        </button>
                                                    </div>
                                                </div>

                                                <div style={{
                                                    backgroundColor: 'white',
                                                    padding: '20px',
                                                    borderRadius: '8px',
                                                    border: '1px solid #e5e7eb'
                                                }}>
                                                    <h4 style={{
                                                        margin: '0 0 10px 0',
                                                        fontSize: '14px',
                                                        fontWeight: '600',
                                                        color: '#374151'
                                                    }}>
                                                        Marketing Communications
                                                    </h4>
                                                    <p style={{
                                                        margin: '0 0 15px 0',
                                                        fontSize: '13px',
                                                        color: '#6b7280'
                                                    }}>
                                                        Receive promotional offers and business insights
                                                    </p>
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between'
                                                    }}>
                                                        <span style={{
                                                            fontSize: '13px',
                                                            color: '#ef4444',
                                                            fontWeight: '500'
                                                        }}>
                                                            Disabled
                                                        </span>
                                                        <button
                                                            onClick={() => alert('Marketing preferences updated')}
                                                            style={{
                                                                padding: '6px 12px',
                                                                backgroundColor: '#8b5cf6',
                                                                color: 'white',
                                                                border: 'none',
                                                                borderRadius: '6px',
                                                                cursor: 'pointer',
                                                                fontSize: '12px',
                                                                fontWeight: '500'
                                                            }}
                                                        >
                                                            Enable
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Push Notifications Section */}
                                        <div style={{
                                            marginTop: '30px',
                                            padding: isMobile ? '20px' : '30px',
                                            backgroundColor: '#f9fafb',
                                            borderRadius: '12px',
                                            border: '1px solid #e5e7eb'
                                        }}>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '15px',
                                                marginBottom: '20px'
                                            }}>
                                                <div style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '8px',
                                                    backgroundColor: '#fef3c7',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    color: '#d97706',
                                                    fontSize: '18px'
                                                }}>
                                                    <FaMobileAlt />
                                                </div>
                                                <div>
                                                    <h3 style={{
                                                        margin: '0 0 5px 0',
                                                        fontSize: isMobile ? '16px' : '18px',
                                                        fontWeight: '600',
                                                        color: '#1a1a1a'
                                                    }}>
                                                        Push Notifications
                                                    </h3>
                                                    <p style={{
                                                        margin: 0,
                                                        fontSize: isMobile ? '13px' : '14px',
                                                        color: '#666'
                                                    }}>
                                                        Configure mobile push notification settings
                                                    </p>
                                                </div>
                                            </div>
                                            <div style={{
                                                backgroundColor: 'white',
                                                padding: '20px',
                                                borderRadius: '8px',
                                                border: '1px solid #e5e7eb'
                                            }}>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    flexDirection: isMobile ? 'column' : 'row',
                                                    gap: isMobile ? '15px' : '0'
                                                }}>
                                                    <div>
                                                        <h4 style={{
                                                            margin: '0 0 5px 0',
                                                            fontSize: '16px',
                                                            fontWeight: '600',
                                                            color: '#374151'
                                                        }}>
                                                            Enable Push Notifications
                                                        </h4>
                                                        <p style={{
                                                            margin: 0,
                                                            fontSize: '14px',
                                                            color: '#6b7280'
                                                        }}>
                                                            Receive instant alerts on your mobile device
                                                        </p>
                                                    </div>
                                                    <div style={{
                                                        display: 'flex',
                                                        gap: '10px',
                                                        alignItems: 'center'
                                                    }}>
                                                        <span style={{
                                                            fontSize: '14px',
                                                            color: '#10b981',
                                                            fontWeight: '500'
                                                        }}>
                                                            Active
                                                        </span>
                                                        <button
                                                            onClick={() => alert('Push notification settings updated')}
                                                            style={{
                                                                padding: '8px 16px',
                                                                backgroundColor: '#f59e0b',
                                                                color: 'white',
                                                                border: 'none',
                                                                borderRadius: '6px',
                                                                cursor: 'pointer',
                                                                fontSize: '14px',
                                                                fontWeight: '600'
                                                            }}
                                                        >
                                                            Manage Settings
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}

                                {/* Notification History Tab Content */}
                                {activeTab === "Notification History" && (
                                    <FoodNotificationHistory isMobile={isMobile} />
                                )}

                                {/* Custom Alert Configuration Tab Content */}
                                {activeTab === "Custom Alert" && (
                                    <FoodCustomAlerts isMobile={isMobile} />
                                )}

                                {/* Footer Note */}
                                <div style={{
                                    marginTop: '30px',
                                    padding: '20px',
                                    backgroundColor: '#f9fafb',
                                    borderRadius: '12px',
                                    textAlign: 'center',
                                    border: '1px solid #e5e7eb'
                                }}>
                                    <p style={{
                                        margin: '0',
                                        fontSize: isMobile ? '13px' : '14px',
                                        color: '#6b7280',
                                        lineHeight: 1.6
                                    }}>
                                        <FaCog style={{ marginRight: '8px', color: '#9ca3af' }} />
                                        Notification preferences are updated in real-time. Some changes may take a few minutes to propagate.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NotificationHub;